import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/@/components/ui/table";
import { Button } from "src/@/components/ui/button";
import Iconify from 'src/components/Iconify';

export default function TableOrigins({ data, onEdit, onDelete }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nome</TableHead>
          <TableHead className="text-right">Ações</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.map((origin) => (
          <TableRow key={origin._id}>
            <TableCell className="font-medium">{origin.name}</TableCell>
            <TableCell className="text-right">
              <div className="flex justify-end gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onEdit(origin)}
                >
                  <Iconify icon="heroicons:pencil-16-solid" className="h-4 w-4" />
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onDelete(origin)}
                  className="text-red-600 hover:text-red-700"
                >
                  <Iconify icon="heroicons:trash-16-solid" className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
